import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { translationChunksConfig } from '@spartacus/assets';
import {
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideConfig
} from '@spartacus/core';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { NeedAssistanceModule } from '../shared/modules/need-assistance/need-assistance.module';
import { RecaptchaService } from '../shared/services/recaptcha.service';
import { ForgotUserPasswordComponent } from './forgot-user-password/forgot-user-password.component';
import { HelpHintRecoveryQuestionComponent } from './help-hint-recovery-question/help-hint-recovery-question.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { UserDataRecoveryActionComponent } from './user-data-recovery-action/user-data-recovery-action.component';

export function loadRecaptcha(recaptchaService: RecaptchaService): () => Promise<void> {
  return () => recaptchaService.loadRecaptchaConfig();
}
@NgModule({
  declarations: [
    ForgotUserPasswordComponent,
    SetPasswordComponent,
    HelpHintRecoveryQuestionComponent,
    UserDataRecoveryActionComponent,
    LoginPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    NeedAssistanceModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        LoginHelpComponent: {
          component: () =>
            import(
              './forgot-user-password/forgot-user-password.component'
            ).then((m) => m.ForgotUserPasswordComponent),
        },
        UserNameRecoverySuccessComponent: {
          component: () =>
            import(
              './user-data-recovery-action/user-data-recovery-action.component'
            ).then((m) => m.UserDataRecoveryActionComponent),
        },
        HintQuestionAnswerComponent: {
          component: () =>
            import(
              './help-hint-recovery-question/help-hint-recovery-question.component'
            ).then((m) => m.HelpHintRecoveryQuestionComponent),
        },
        ForgotPasswordComponent: {
          component: () =>
            import('./set-password/set-password.component').then(
              (m) => m.SetPasswordComponent
            ),
        },
        LoginPageReferenceComponent: {
          component: () =>
            import('./login-page/login-page.component').then(
              (m) => m.LoginPageComponent
            ),
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
    {
      provide: APP_INITIALIZER,
      deps: [RecaptchaService],
      useFactory: loadRecaptcha,
      multi: true,
    }
  ],
})
export class ForgotUserPasswordModule { }
